<div>
    <img src="assets/images/carelflex-logo.png"/>
    <h1 class="title">Mission Configurator</h1>
    <button (click)="login()">LOGIN</button>
    <a class="error">{{ infoMessage }}</a>
</div>